(function () {
  "use strict";
  function init(root) {
    if (root.dataset.v4Ready) return;
    root.dataset.v4Ready = "true";
    var key = root.dataset.packageKey,
      single = root.dataset.accordionBehavior === "single",
      panels = [...root.querySelectorAll("[data-accordion]")],
      busy = false;
    function activate(selection) {
      root.hidden = !selection || selection.key !== key;
    }
    window.Naxarly?.ServicePage?.subscribe(activate);
    activate(window.Naxarly?.ServicePage?.getSelection?.());
    panels.forEach((panel) =>
      panel.addEventListener("toggle", function () {
        if (!single || busy || !panel.open) return;
        busy = true;
        panels.forEach((other) => {
          if (other !== panel) other.open = false;
        });
        busy = false;
      }),
    );
    root.querySelectorAll("[data-gallery]").forEach((gallery) => {
      var holder = gallery.querySelector("[data-gallery-tabs]"),
        tabPanels = [...gallery.querySelectorAll("[data-gallery-tab-panel]")];
      function select(index) {
        [...holder.children].forEach((button, i) => {
          var on = i === index;
          button.classList.toggle("is-active", on);
          button.setAttribute("aria-selected", String(on));
          button.tabIndex = on ? 0 : -1;
        });
        tabPanels.forEach((panel, i) => (panel.hidden = i !== index));
      }
      tabPanels.forEach((panel, index) => {
        var button = document.createElement("button"),
          icon = document.createElement("span"),
          label = document.createElement("span");
        button.type = "button";
        button.setAttribute("role", "tab");
        icon.setAttribute("aria-hidden", "true");
        icon.textContent = panel.dataset.tabIcon || "";
        label.textContent = panel.dataset.tabTitle;
        button.append(icon, label);
        button.addEventListener("click", () => select(index));
        holder.append(button);
      });
      if (tabPanels.length) select(0);
    });
    var dialog = root.querySelector("[data-lightbox-dialog]"),
      stage = root.querySelector("[data-lightbox-content]"),
      counter = root.querySelector("[data-lightbox-counter]"),
      sequence = [],
      index = 0,
      lastTrigger = null,
      startX = 0,
      lastTap = 0;
    function pause() {
      dialog?.querySelectorAll("video").forEach((v) => v.pause());
    }
    function prepareVideo(video) {
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.preload = "auto";
      video.setAttribute("controlsList", "nodownload");
      video.setAttribute("disableRemotePlayback", "");
      video.addEventListener("contextmenu", (event) => event.preventDefault());
      video.load();
      video.play().catch(() => {
        // Some browsers still require the customer to press Play.
      });
    }
    function render() {
      pause();
      stage.replaceChildren();
      var trigger = sequence[index];
      if (!trigger) return;
      if (trigger.dataset.lightbox === "image") {
        var image = trigger.querySelector("img")?.cloneNode();
        if (image) {
          image.removeAttribute("loading");
          image.addEventListener("click", () => {
            var now = Date.now();
            if (now - lastTap < 320) image.classList.toggle("is-zoomed");
            lastTap = now;
          });
          stage.append(image);
        }
      } else {
        var template = trigger.querySelector("template");
        if (template) {
          stage.append(template.content.cloneNode(true));
          var video = stage.querySelector("video");
          if (video) prepareVideo(video);
        }
      }
      counter.textContent = index + 1 + " / " + sequence.length;
    }
    function move(n) {
      if (!sequence.length) return;
      index = (index + n + sequence.length) % sequence.length;
      render();
    }
    function close() {
      pause();
      if (dialog?.open) dialog.close();
      stage.replaceChildren();
      document.documentElement.style.overflow = "";
      lastTrigger?.focus();
    }
    root.querySelectorAll("[data-lightbox]").forEach((trigger) =>
      trigger.addEventListener("click", () => {
        sequence = [
          ...trigger
            .closest("[data-gallery-tab-panel]")
            .querySelectorAll("[data-lightbox]"),
        ];
        index = sequence.indexOf(trigger);
        lastTrigger = trigger;
        dialog.showModal();
        document.documentElement.style.overflow = "hidden";
        render();
      }),
    );
    root
      .querySelector("[data-lightbox-prev]")
      ?.addEventListener("click", () => move(-1));
    root
      .querySelector("[data-lightbox-next]")
      ?.addEventListener("click", () => move(1));
    root
      .querySelector("[data-lightbox-close]")
      ?.addEventListener("click", close);
    dialog?.addEventListener("cancel", (e) => {
      e.preventDefault();
      close();
    });
    dialog?.addEventListener("keydown", (e) => {
      if (e.target instanceof HTMLVideoElement) return;
      if (e.key === "ArrowLeft") move(-1);
      if (e.key === "ArrowRight") move(1);
    });
    dialog?.addEventListener("pointerdown", (e) => (startX = e.clientX));
    dialog?.addEventListener("pointerup", (e) => {
      if (e.target instanceof HTMLVideoElement) return;
      if (Math.abs(e.clientX - startX) > 48) move(e.clientX > startX ? -1 : 1);
    });
  }
  function customize(event) {
    var d = event.detail || {},
      root = [...document.querySelectorAll("[data-nsc-modular]")].find(
        (x) => x.dataset.packageKey === d.packageKey,
      );
    if (!root) return;
    var target = d.target
        ? root.querySelector('[data-addon-key="' + CSS.escape(d.target) + '"]')
        : null,
      panel = target?.closest("[data-accordion]");
    if (!panel && d.target)
      panel = root.querySelector(
        '[data-content-key="' + CSS.escape(d.target) + '"]',
      );
    if (!panel) panel = root.querySelector('[data-layout="add_on_cards"]');
    if (!panel) return;
    panel.open = true;
    requestAnimationFrame(() => {
      (target || panel).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      if (target) {
        target.classList.add("is-highlighted");
        setTimeout(() => target.classList.remove("is-highlighted"), 1600);
      }
    });
  }
  function boot() {
    document.querySelectorAll("[data-nsc-modular]").forEach(init);
  }
  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", boot)
    : boot();
  document.addEventListener("shopify:section:load", boot);
  window.addEventListener("naxarly:customize", customize);
})();
